import React from 'react';
import { Zap, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Services = () => {
  const electricalServices = [
    'Management systems',
    'Electrical distribution systems',
    'Medium and low voltage switchgears and cabling',
    'Low voltage power & control systems',
    'Structured cabling - fiber-to-fiber and copper-to-fiber',
    'Fire alarm and emergency lighting systems',
    'CCTV, security and surveillance systems',
    'Access control, timed attendance - card and biometric systems',
    'Audio/video intercom systems',
    'Public address systems/BGM',
    'Total data center solutions',
    'Central battery and UPS systems',
    'Dimmer controls',
    'Gate barrier systems',
    'Substations up to 132 KV',
    'External lighting',
    'HT/LT systems',
    'Underground cabling and transmission lines',
    'Fit-out electrical works for corporations'
  ];

  return (
    <div className="min-h-screen bg-slate-50" data-testid="services-page">
      {/* Hero Section */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Services</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Comprehensive electrical engineering solutions delivered across India
          </p>
        </div>
      </section>

      {/* Electrical Services */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <Card className="shadow-xl border-none">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-8">
              <div className="flex items-center gap-4">
                <Zap className="h-12 w-12" />
                <CardTitle className="text-4xl">Electrical Services</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="p-8">
              <p className="text-lg text-slate-700 mb-6">
                We offer complete electrical services, including:
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {electricalServices.map((service, index) => (
                  <div key={index} className="flex items-start gap-3" data-testid={`electrical-service-${index}`}>
                    <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">{service}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Services;
